var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5206_3090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9887 20.6689C25.6767 15.981 25.6767 8.38034 20.9887 3.6924C16.3008 -0.995541 8.70013 -0.995541 4.01219 3.6924C-0.675748 8.38034 -0.675748 15.981 4.01219 20.6689C8.70013 25.3569 16.3008 25.3569 20.9887 20.6689Z",
    fill: "#FF4141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1562 17.5295L7.67034 9.0437C7.20298 8.57644 7.20298 7.81407 7.67034 7.34671C8.13771 6.87935 8.90017 6.87925 9.36743 7.34661L17.8533 15.8324C18.3206 16.2997 18.3206 17.0621 17.8533 17.5294C17.3859 17.9968 16.6234 17.9969 16.1562 17.5295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67034 15.8324L16.1562 7.34661C16.6234 6.87925 17.3858 6.87925 17.8532 7.34661C18.3205 7.81397 18.3206 8.57644 17.8533 9.0437L9.36743 17.5295C8.90017 17.9969 8.1378 17.9969 7.67044 17.5295C7.20308 17.0622 7.20298 16.2997 7.67034 15.8324Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5206_3090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.179688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/red-cross.d06f99d9ce74c4ee0e132de3c4166d0e.svg";
export { ForwardRef as ReactComponent };